import React from 'react';
import PropTypes from 'prop-types';
import * as R from 'ramda/src/index';
import classnames from 'classnames';
import {trustpilot} from 'ferries/Home/components/Testimonials/helper';

const TestimonialStars = ({source, stars}) => {
  const isTrustPilot = source === trustpilot;

  const starsIcon = classnames('icon icon-shape-star-4', {
    'icon-sm bg-success text-white': isTrustPilot,
    'icon-sm bg-white text-warning': !isTrustPilot
  });

  return (
    <div className="mt-3 mt-md-0">
      {R.range(0, stars).map((star) =>
        <i
          key={star}
          style={{marginLeft: '1px', padding: '1px'}}
          className={starsIcon}
        />
      )}
    </div>
  );
};

TestimonialStars.propTypes = {
  source: PropTypes.string.isRequired,
  stars: PropTypes.number.isRequired
};

export default TestimonialStars;
